import React, { Component } from 'react';
import assign from 'object-assign';
import { FormattedDate } from 'react-intl';

import { Card, CardActions } from 'material-ui/Card';
import DetailView from '../Common/DetailView';
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';

import LinearProgress from 'material-ui/LinearProgress';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';

import MailLogActions from '../../actions/MailLogActionCreator';
import MailLogStore from '../../stores/MailLogStore';
import { DateStyles } from '../../constants/CentricConstants';

const tableRow = function(entry) {
    const timestamp = (entry.timestamp || new Date(entry.dateAdded));
    const date = <FormattedDate value={timestamp} {...DateStyles.shortWeekday} />;
    const time = entry.dateAdded.split('T')[1];
    return (
        <TableRow key={entry.id} >
            <TableRowColumn className="maillog--dateAdded" title={entry.dateAdded} >{date} {time}</TableRowColumn>
            <TableRowColumn className="maillog--recipient" title={entry.recipient} >{entry.recipient}</TableRowColumn>
            <TableRowColumn className="maillog--subject" title={entry.subject} >{entry.subject}</TableRowColumn>
            <TableRowColumn className="maillog--result" title={entry.result} >{entry.result}</TableRowColumn>
        </TableRow>
    );
};

const dateSort = function(a, b) {
    return b.timestamp - a.timestamp;
};

class MailLog extends Component {

    constructor (props) {
        super(props);
        this.state = {
            entries: [],
            loading: false,
            page: 0,
            limit: 50,
        };
        this.onChange = this.onChange.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
    }


    componentDidMount() {
        MailLogStore.addChangeListener(this.onChange);
        this.loadNextPage();
    }

    componentWillUnmount() {
        MailLogStore.removeChangeListener(this.onChange);
    }
    
    render() {

        const tableProps = {
            fixedHeader:       true,
            selectable:        false,
        };
        const headerProps = {
            displaySelectAll:  false,
            adjustForCheckbox: false
        };
        const bodyProps = {
            displayRowCheckbox: false,
        };
        let loading;
        if (!!this.state.loading) {
            loading = <LinearProgress mode="indeterminate" />;
        }
        
        return (
            <DetailView title="Email Log" >
                <div className='cent-cards'>
                    <Card className="cent-card">
                        <Table {...tableProps}>
                            <TableHeader {...headerProps}>
                                <TableRow>
                                    <TableHeaderColumn>Date Sent</TableHeaderColumn>
                                    <TableHeaderColumn>Recipient</TableHeaderColumn>
                                    <TableHeaderColumn>Subject</TableHeaderColumn>
                                    <TableHeaderColumn>Status</TableHeaderColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody {...bodyProps}>
                                {this.state.entries.sort(dateSort).map(tableRow, this)}
                            </TableBody>
                        </Table>
                        <Divider />
                        <CardActions>
                            <FlatButton label="More..." onTouchTap={this.loadNextPage} disabled={this.state.loading} />
                        </CardActions>
                        {loading}
                    </Card>
                </div>
            </DetailView>
        );
    }

    onChange() {
        const entries = MailLogStore.getAll();
        if (entries !== undefined) {
            let state = assign(this.state, {entries: entries, loading: false});
            if (entries.length >= ((this.state.page + 1) * this.state.limit)) {
                ++state.page;
            }
            this.setState(state);
        }
    }
    
    loadNextPage() {
        this.setState({loading: true});
        MailLogActions.getAll({page: this.state.page, limit: this.state.limit});
        if (this.state.page > 0) {
            MailLogActions.getAll({page: 0, limit: this.state.limit});
        }
    }

}

export default MailLog;
